import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { MERCADO_PAGO_URL, SECURE_TEXT } from '../constants/data';
interface CTAButtonProps {
  label: string;
  className?: string;
  showSecureText?: boolean;
  href?: string;
}
export function CTAButton({
  label,
  className = '',
  showSecureText = true,
  href
}: CTAButtonProps) {
  const targetUrl = href || MERCADO_PAGO_URL;
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-70">
      <a href={targetUrl} className="cta-primary inline-flex items-center justify-center gap-2 w-full sm:w-auto text-base sm:text-lg px-7 sm:px-9 py-4 sm:py-[18px] text-center leading-tight" data-id="element-71">
        <ArrowRightIcon className="w-5 h-5 shrink-0" strokeWidth={3} aria-hidden="true" data-id="element-72" />
        <span data-id="element-73">{label}</span>
      </a>
      {showSecureText && <p className="mt-3 text-xs sm:text-sm text-neutral-400 text-center max-w-md" data-id="element-74">
          {SECURE_TEXT}
        </p>}
    </div>;
}